<script setup lang="ts">
import { computed, useAttrs, ref } from 'vue';

defineProps<{
  modelValue: string;
  inputClass?: string;
  label?: string;
  wrapperId?: string;
}>();

defineOptions({ inheritAttrs: false });

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void;
}>();

const attrs = useAttrs();
const inputRef = ref();
const isFocused = ref(false);

const inputKeys = [ 'id', 'type', 'name', 'placeholder', 'autocomplete', 'disabled', 'readonly', 'maxlength', 'minlength', 'required', 'pattern', 'inputmode', 'autofocus' ];

const inputAttrs = computed(() => {
  const filtered: Record<string, unknown> = {};

  for (const key in attrs) {
    if (inputKeys.includes(key)) {
      filtered[key] = attrs[key];
    }
  }

  if (!('type' in filtered)) { filtered.type = 'text'; }
  if (filtered.id) { filtered.name = filtered.id; }

  return filtered;
});

const wrapperAttrs = computed(() => {
  const filtered: Record<string, unknown> = {};
  for (const key in attrs) {
    if (!inputKeys.includes(key)) {
      filtered[key] = attrs[key];
    }
  }
  return filtered;
});

function onInput() { emit('update:modelValue', inputRef.value.value);}
</script>

<template>
  <div
    :id="wrapperId"
    class="
      mui-input
      relative text-brown-600
      flex flex-row justify-center items-center
      h-12 bg-white rounded-md
      gap-2.5 relative
      flex-1
    "
    v-bind="wrapperAttrs"
  >
    <i
      class="
        mi-search text-2xl
        absolute left-4 z-4
        pointer-events-none
      "
    />
    <input
      v-bind="inputAttrs"
      ref="inputRef"
      :value="modelValue"
      class="
        peer
        text-base
        outline-0
        border-0
        bg-white
        py-3 pr-4 pl-12.5
        focus:border-brown-600
        relative z-2
        flex-1
        rounded-md
        h-full
      "
      :class="inputClass"
      :placeholder="label"
      autocomplete="off"
      @input="onInput"
      @focus="isFocused = true"
    >
  </div>
</template>
